import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useActionSheet } from "@expo/react-native-action-sheet";
import { AHTodoCategoryIcon } from "arkh";
import React, { useMemo, useCallback } from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { ProductLinkedTodosFloatingAddButton_Store$key } from "./__generated__/ProductLinkedTodosFloatingAddButton_Store.graphql";
import { FloatingAddButton } from "./FloatingAddButton";

export function ProductLinkedTodosFloatingAddButton(props: {
  store: ProductLinkedTodosFloatingAddButton_Store$key;
  addTodo: (categoryId: string) => void;
}) {
  const actionSheet = useActionSheet();
  const intl_tokens = useIntlTokens();
  const store = useFragment(
    graphql`
      fragment ProductLinkedTodosFloatingAddButton_Store on Store {
        todoCategories(includeDefault: true) {
          id
          title
          icon
        }
      }
    `,
    props.store
  );
  const options = useMemo(
    () => [
      { title: intl_tokens.Cancel, icon: null, type: "cancel" as const },
      ...store.todoCategories
        .map(({ title, id, icon }) => ({
          id,
          title,
          icon: <AHTodoCategoryIcon icon={icon ?? "Check"} />,
          type: "todo" as const,
        }))
        .sort((a, b) =>
          a.title.toLocaleLowerCase() > b.title.toLocaleLowerCase() ? 1 : -1
        ),
    ],
    [store.todoCategories, intl_tokens.Cancel]
  );

  const openAdd = useCallback(() => {
    if (options.length === 2) {
      const option = options[1];
      if (option.type === "todo") {
        props.addTodo(option.id);
      }
    } else if (options.length > 2) {
      actionSheet.showActionSheetWithOptions(
        {
          options: options.map(({ title }) => title),
          tintIcons: true,
          icons: options.map(({ icon }) => icon),
          cancelButtonIndex: 0,
        },
        (i) => {
          if (i === undefined || i < 0 || i >= options.length) {
            return;
          }
          const option = options[i];
          if (option.type === "todo") {
            props.addTodo(option.id);
          }
        }
      );
    }
  }, [actionSheet, options, props]);
  return <FloatingAddButton onPress={openAdd} />;
}
